<template v-slot:default="{ isActive }">
  <v-dialog
    v-model="dialog"
    width="60rem"
    class="layer-popup"
    scrollable
  >
    <v-card>
      <!--content-->
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="pop-title">
          {{t('message.viewDetails')}}
          <div class="sub-txt02">
            <div class="col">
              {{t('message.safetyTalk')}} <span>{{ timelineType1Cnt }}</span>
            </div>
            <div class="line"></div>
            <div class="col">
              칭찬대화 <span>{{ timelineType2Cnt }}</span>
            </div>
          </div>
        </div>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click.stop="dialog = false"
        ></v-btn>
      </v-card-title>

      <v-divider class="mb-4"></v-divider>
      <!--content-->
      <v-card-text>
        <div class="slider-group">
          <v-slide-group
            v-model="model"
            center-active
            show-arrows
            delimiters
          >
            <v-slide-group-item
              v-for="(item,i) in items"
              :key="i"
              v-slot="{ isSelected, toggle }"
            >
              <v-card
                @click="toggle"
              >
                <div class="slider-item">
                  <div class="img-slider">
                    <v-carousel
                    >
                      <v-carousel-item
                        v-for="(item2,i2) in item.timelineImages"
                        :key="i2"
                        :src="utils.getBaseUrl('timeline', item2.filePath)"
                        cover
                        @click="onClickPreview(item2)"
                      ></v-carousel-item>
                    </v-carousel>
                  </div>
                  <div @click="utils.movePage('/myBoardDetail/'+item.idx)">
                    <div class="txt-group">
                      <div class="txt ell01">{{ item.memberName?item.memberName:t('message.noInfo') }} / {{ item.deptName?item.deptName:t('message.noInfo') }} / {{ item.posName?item.posName:t('message.noInfo') }}</div>
                      <div class="txt2">{{ item.regDateFormat }}</div>
                    </div>
                    <ul class="txt-group2">
                      <li v-if="item.type=='1'">
                        <div class="tit">{{t('message.monitoringBehavior')}}</div>
                        <div class="txt ell01">{{ item.behaviorTitle }}</div>
                      </li>
                      <li v-if="item.type=='1'">
                        <div class="tit">{{t('message.location')}}</div>
                        <div class="txt ell01">{{ item.placeName }}</div>
                      </li>
                      <li>
                        <div class="tit">{{item.type=='1'?t('message.specificSituation'):t('message.praiseReason')}}</div>
                        <div class="txt ell01">{{ item.situation }}</div>
                      </li>
                      <li v-if="item.type=='1'">
                        <div class="tit">{{t('message.cause')}}</div>
                        <div class="txt ell01">{{ item.cause }}</div>
                      </li>
                      <li v-if="item.type=='1'">
                        <div class="tit">{{t('message.correctiveActionDetails')}}</div>
                        <div class="txt ell01">{{ item.action }}</div>
                      </li>
                      <li>
                        <div class="tit">{{item.type=='1'?t('message.correctiveActionTarget'):t('message.praiseTarget')}}</div>
                        <div class="txt ell01">{{ item.targetText }}</div>
                      </li>
                      <li v-if="item.actionYn=='Y'">
                        <div class="tit">{{t('message.actionDeadline')}}</div>
                        <div class="txt ell01">{{ item.goalDate }}</div>
                      </li>
                      <li v-if="item.type=='1'">
                        <div class="tit">{{t('message.progressStatus')}}</div>
                        <div class="txt2 c01">{{ item.statusText }}</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </v-card>
            </v-slide-group-item>
          </v-slide-group>
        </div>
      </v-card-text>
      <!--버튼-->
      <v-card-actions class=" d-flex justify-end pop-bottom-bg">
        <c-btn01 :btnText="t('message.confirm')" @click="dialog=false"/>
      </v-card-actions>
    </v-card>
    <AmDialog01 v-model="detailPopupModel" @close="detailPopupModel=false"/>
    <DialogImgView v-model="previewDialog" @close="previewDialog=false" :src="previewSrc"/>
    <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TimelineService from "@/services/timeline.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const dialog = defineModel()

//bind
const snackbar = ref(false)
const snackText = ref('')
const items = ref([])

//ui
const detailPopupModel = ref(false)
const previewDialog = ref(false)
const previewSrc = ref('')
const model = ref(false)
const timelineType1Cnt = ref(0)
const timelineType2Cnt = ref(0)

//hook
onUpdated(() => {
  if(dialog.value)
    onClickSearch()
})

function onClickSearch(){
  let params:any = storeRef.popupParams.value
  params.idx = null

  TimelineService.getTimelineList(params).then(
    (response) => {
      //타임라인
      items.value = response.result
      _.forEach(items.value, function(val, key) {
        val.typeText = val.type=='1'?t('message.correctiveSafetyTalk'):t('message.supportiveSafetyTalk')
        val.actionYnText = val.actionYn=='Y'?t('message.necessary'):t('message.notNecessary')
        val.targetText = t('message.none')
        if(val.targetType == '2') val.target = val.targetDept
        else if(val.targetType == '3') val.target = val.targetMember
        val.goalDate = dayjs(val.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(val.goalDate).format('YYYY-MM-DD')
        val.statusText = t('message.ready')
        if(val.status == '2')
          val.statusText = t('message.inProgress')
        else if(val.status == '3')
          val.statusText = t('message.onHold')
        else if(val.status == '4')
          val.statusText = t('message.complete')
      })

      timelineType1Cnt.value = _.filter(items.value, {type:'1'}).length
      timelineType2Cnt.value = _.filter(items.value, {type:'2'}).length
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

function onClickPreview(item){
  previewSrc.value = utils.getBaseUrl('timeline', item.filePath)
  previewDialog.value = true
}
</script>


<style lang="scss">
</style>
